import React from "react";
import Reveal from "./Reveal";
import { AlertTriangle, MessageSquare, Plug } from "lucide-react";

const CARDS = [
  {
    icon: AlertTriangle,
    title: "Mucho trabajo, poca claridad",
    text: "Cada día haces cosas, pero no sabes qué mueve realmente el negocio.",
  },
  {
    icon: MessageSquare,
    title: "Leads que preguntan y se enfrían",
    text: "Oportunidades que llegan por WhatsApp, web o redes y no tienen seguimiento.",
  },
  {
    icon: Plug,
    title: "Herramientas sueltas",
    text: "Excel, WhatsApp, CRM, email y memoria funcionando cada uno por su lado.",
  },
];

const Problem = () => {
  return (
    <section
      id="problema"
      data-testid="problem-section"
      className="et-section relative"
    >
      <div
        aria-hidden
        className="et-orb"
        style={{
          top: "10%",
          right: "-15%",
          width: "420px",
          height: "420px",
          background: "#13283d",
          opacity: 0.55,
        }}
      />

      <div className="et-container relative z-10">
        <Reveal>
          <div className="et-eyebrow">El problema real</div>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-8 mt-5 items-end">
          <Reveal delay={0.05} className="lg:col-span-7">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] text-white et-text-balance">
              Tu negocio no necesita más herramientas.{" "}
              <span className="et-text-gold">Necesita menos caos.</span>
            </h2>
          </Reveal>

          <Reveal delay={0.15} className="lg:col-span-5">
            <p className="text-base md:text-lg text-[#f5f2ea]/90 leading-relaxed">
              Muchas pymes tienen ventas, clientes, procesos, seguimiento y
              decisiones repartidas entre WhatsApp, Excel, memoria y urgencias.
              Meter IA encima de eso solo acelera el desorden.
            </p>
          </Reveal>
        </div>

        {/* Cards */}
        <div className="mt-10 md:mt-12 grid md:grid-cols-3 gap-5 md:gap-6">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={0.08 + i * 0.08}>
              <div
                className="et-card h-full"
                data-testid={`problem-card-${i}`}
              >
                <div
                  className="w-11 h-11 rounded-xl grid place-items-center mb-5"
                  style={{
                    background: "rgba(197,160,89,0.1)",
                    border: "1px solid rgba(197,160,89,0.3)",
                  }}
                >
                  <c.icon className="w-5 h-5 text-[#c5a059]" />
                </div>
                <h3 className="text-lg md:text-xl font-semibold text-white tracking-tight">
                  {c.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-[#f5f2ea]/80 leading-relaxed">
                  {c.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Hard-hitting pull quote */}
        <Reveal delay={0.25}>
          <div
            className="mt-10 md:mt-12 border-l-2 border-[#c5a059] pl-5 md:pl-6 max-w-3xl"
            data-testid="problem-pullquote"
          >
            <p className="text-lg md:text-2xl text-white font-semibold leading-snug tracking-tight">
              Porque automatizar un proceso roto solo consigue una cosa:{" "}
              <span className="et-text-gold">romperlo más rápido.</span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Problem;
